import React from 'react';
import styles from './formsBrowser.module.scss';
import { useTranslation } from 'react-i18next';
import { FilterProps } from './types/FormTypes';

export const FormsHomeFilterTitle = React.memo(
    (props: { filterProps: FilterProps }) => {
        const { t } = useTranslation();

        try {
            const {
                filterProps: {
                    categoryFilterSelected,
                    departmentFilterSelected,
                },
            } = props;

            if (
                categoryFilterSelected !== 'No Filter' &&
                departmentFilterSelected === 'No Filter'
            ) {
                return (
                    <div className={styles.filterSelectedTitleContainer}>
                        {categoryFilterSelected}
                    </div>
                );
            } else if (
                categoryFilterSelected === 'No Filter' &&
                departmentFilterSelected !== 'No Filter'
            ) {
                return (
                    <div className={styles.filterSelectedTitleContainer}>
                        {departmentFilterSelected}
                    </div>
                );
            } else {
                return (
                    <div className={styles.filterSelectedTitleContainer}>
                        {t('FormsBrowser.FilterTitleDefault')}
                    </div>
                );
            }
        } catch {
            return null;
        }
    },
);
